<template>
    <div class="animated fadeIn">
      <b-card class="card-accent-info" header="Contratos">
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
                
              <!--
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
                </b-form-group>
             -->
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                
                <b-button variant="vine" class="mr-1 btn-brand" @click="openBulkModal()"  v-show="tableSelectable"><i class="fa fa-stack-exchange"></i><span>Registrar em Lote</span></b-button>
                
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Contrato</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
              
  
          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    @change="changeCompany"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Departamento</label>
                  <b-form-select id="department"
                    v-model="filters.departmentId"
                    :plain="true"
                    :options="selectDepartmentDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>
  
            <b-col cols="auto">
              <b-form-group>
                  <label for="name" style="font-size: 0.8em">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
        
    
            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Tipo de Contrato</label>
                  <b-form-select id="registeredId"
                    v-model="filters.typeId"
                    :plain="true"
                    :options="selectContractTypeDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Status</label>
                  <b-form-select id="statusId"
                    v-model="filters.statusId"
                    :plain="true"
                    :options="selectContractStatusDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>


            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Ativo/Inativo</label>
                  <b-form-select id="status"
                    v-model="filters.status"
                    :plain="true"
                    :options="statusddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>
  
            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                      <b-row v-if="row.item.description">
                            <b-col>Descrição: <b>{{ row.item.description }}</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col>Licença: <b>{{ row.item.licenseKey ? row.item.licenseKey : 'Sem licença' }}</b></b-col>
                        </b-row>
                        <b-row v-if="row.item.approver">
                            <b-col>Registrado de <b>{{ $utils.dateStringFormat(row.item.licensedSince) }}</b> a <b>{{ $utils.dateStringFormat(row.item.licensedUntil) }}</b> por <b>[{{ row.item.approver.username }}] {{ row.item.approver.name }}</b></b-col>
                        </b-row>
                    </b-card>
                </template>
                
                <template v-slot:cell(originalValue)="data">
                    {{ !isNaN(data.item.originalValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.originalValue) : '' }}
                </template>
  
                <template v-slot:cell(paymentValue)="data">
                    {{ !isNaN(data.item.paymentValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.paymentValue) : '' }}
                </template>
  
                <template v-slot:cell(action)="data">
                  <!--
                          <b-button size="sm" variant="vimeo" @click="approve(data.item)" class="mr-1 btn-brand" title="Aprovar dispositivo" style="margin-bottom: 4px">
                          <i class="fa fa-handshake-o"></i></b-button>
                  -->
                          <b-button size="sm" variant="dropbox" @click="openActionModal(data.item)" class="mr-1 btn-brand" title="Ação" style="margin-bottom: 4px" :disabled="!(editAccess || $store.state.currentUser.id == data.item.responsible.id)">
                          <i class="fa fa-tasks"></i></b-button>

                          <!--
                          <b-button size="sm" variant="dropbox" @click="resync(data.item)" class="mr-1 btn-brand" title="Sincronizar" style="margin-bottom: 4px">
                          <i class="fa fa-refresh"></i></b-button>
                        -->
                          
                </template>

                <template v-slot:cell(startDate)="data">
                    {{ $utils.dateStringFormat( data.item.startDate ) }}
                </template>

                <template v-slot:cell(renewalDate)="data">
                    {{ $utils.dateStringFormat( data.item.renewalDate ) }}
                </template>

                <template v-slot:cell(name2)="data">
                        <b>{{ data.item.name }}</b><br>
                        <span class="text-primary">{{ data.item.typeName }} </span><span class="text-primary" v-show="data.item.departmentName"> - {{ data.item.departmentName }} </span><br>
                        <span v-if="data.item.description">{{ data.item.description }} <br></span>
                        <span class="small">Responsável: {{ data.item.responsible.name }}</span>
                </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" :disabled="!(editAccess || $store.state.currentUser.id == data.item.responsible.id)"/> 
                </template>
                
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
     
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Contrato"
              size="lg">
  
          <b-nav fill>
            <b-nav-item :active="tabInfo=='C'" @click="tabInfo='C'">Contrato</b-nav-item>
            <b-nav-item :active="tabInfo=='D'" @click="tabInfo='D'">Documentos/Arquivos</b-nav-item>
            <b-nav-item :active="tabInfo=='H'" @click="tabInfo='H'">Histórico</b-nav-item>
          </b-nav>
          
      <b-card v-show="tabInfo=='D'">
       
        <b-card>
          <b-table :items="fileItems" :fields="fileFields" :select-mode="fileSelectMode" responsive="sm" :primary-key="primaryKey" :tbody-transition-props="transProps" sort-icon-left
                      per-page="50" current-page="1" :busy="isBusyFile" hover striped>
                    

            <template #table-busy>

              <div class="text-center text-danger my-2">

                  <b-spinner class="align-middle"></b-spinner>

                  <strong>Carregando...</strong>

              </div>
            </template>
                          
            <!-- Example scoped slot for select state illustrative purposes -->
            <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                
                                  <span aria-hidden="true">&check;</span>
                
                                  <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    
                    <span class="sr-only">Not selected</span>
                </template>
            </template>

            <template v-slot:cell(createdIn)="data">
                {{ $utils.dateTimeStringFormat( data.item.createdIn ) }}
            </template>

            <template v-slot:cell(action)="data">
              <b-button size="sm" variant="primary" @click="openDocumentModal(data.item)" class="mr-1 btn-brand"><i class="fa fa-file-pdf-o"></i></b-button>
            </template>
          </b-table>
        </b-card>

          <b-card v-show="selectedItem.id && selectedItem.id > 0 && (editAccess || !selectedItem.id || selectedItem.id <= 0 || (selectedItem.responsible && $store.state.currentUser.id == selectedItem.responsible.id))">
            <b-form @submit.stop.prevent="onSubmit">

              <div class="d-flex mb-3">
                  <file-drop-area-component v-model="fileToSend" class="w-100"></file-drop-area-component>
              </div>
              <b-form-textarea
                    id="description"
                    v-model="fileDescription"
                    placeholder="Descrição do arquivo"
                    rows="3"
              ></b-form-textarea>
              <p></p>
              <div class="d-flex mb-3  justify-content-center">
                  <b-button :disabled="!fileToSend || !selectedItem.id" variant="primary" @click="uploadFile" >Enviar Arquivo</b-button>                  
              </div>

             


              </b-form>
          </b-card>
      </b-card>


      <b-card v-show="tabInfo=='H'">
      
        <b-table :items="historyItems" :fields="historyFields" :select-mode="historySelectMode" responsive="sm" :primary-key="primaryKey" :tbody-transition-props="transProps" sort-icon-left
                    per-page="50" current-page="1" :busy="isBusyHistory" hover striped>
                  

          <template #table-busy>

            <div class="text-center text-danger my-2">

                <b-spinner class="align-middle"></b-spinner>

                <strong>Carregando...</strong>

            </div>
          </template>
                        
          <!-- Example scoped slot for select state illustrative purposes -->
          <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
              
                                <span aria-hidden="true">&check;</span>
              
                                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  
                  <span class="sr-only">Not selected</span>
              </template>
          </template>

          <template v-slot:cell(createdIn)="data">
              {{ $utils.dateTimeStringFormat( data.item.createdIn ) }}
          </template>

          <template v-slot:cell(action)="data">
            <b-button size="sm" variant="danger" @click="deleteGroupAccess(selectedItem.id, data.item.accessId)" class="mr-1 btn-brand"><i class="fa fa-close"></i></b-button>
          </template>
        </b-table>

      </b-card>


      <b-card v-show="tabInfo=='C'">
        <b-form @submit.stop.prevent="onSubmit">
  
        <div class="animated fadeIn">
      
     
          <b-row>
          <b-col md="12">
            <b-form>
              <b-form-group
              description=""
              label="Departamento"
              label-for="department"
              :label-cols="3"
              :horizontal="true">
              <b-form-select id="department"
                v-model="selectedItem.departmentId"
                :plain="true"
                :options="departmentDDLOrdered">
              </b-form-select>
            </b-form-group>          
            </b-form>
          </b-col>
        </b-row>


        <hr>

        
        <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Nº Contrato/Proposta"
                label-for="code"
                :label-cols="3"
                :horizontal="true">
                <b-form-input  class="text-uppercase" v-model="selectedItem.code" id="code" type="text" ></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>

          

        <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Contrato"
                label-for="name"
                :label-cols="3"
                :horizontal="true">
                <b-form-input  class="text-uppercase" v-model="selectedItem.name" id="name" type="text" ></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>


          <b-row>
              <b-col md="12">
                <b-form>
                  <b-form-group
                  description=""
                  label="Descrição"
                  label-for="description"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-textarea
                    id="description"
                    v-model="selectedItem.description"
                    placeholder=""
                    rows="3"
                  ></b-form-textarea>
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>

          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="CPF/CNPJ"
                label-for="personDoc"
                :label-cols="3"
                :horizontal="true">
                <b-input-group  style="width: 300px">
                    <b-input-group-append><b-input-group-text><i class="fa fa-id-card"></i></b-input-group-text></b-input-group-append>
                    <masked-input
                            type="text"
                            name="doc"
                            class="form-control cols-md-2"
                            v-model="selectedItem.personDoc"
                            :mask="selectedItem && selectedItem.personDoc && selectedItem.personDoc.length > 14 ? [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/] : [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
                            :guide="false"
                            placeholderChar="#"
                            >
                          </masked-input>
                </b-input-group>
              </b-form-group>          
              </b-form>
            
            </b-col>
          </b-row>
          
          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Fornecedor/Cliente"
                label-for="personName"
                :label-cols="3"
                :horizontal="true">
                <b-form-input  class="text-uppercase" v-model="selectedItem.personName" id="personName" type="text" ></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>



            
            <b-row >
              <b-col md="12">
                <b-form>
                  <b-form-group
                  description=""
                  label="Emissão/Data de Início"
                  label-for="startDate"
                  :label-cols="3"
                  :horizontal="true">

                  <b-row>
                    <b-col>
                      <b-form-input v-model="selectedItem.startDate" type="date" id="startDate"></b-form-input>
                    </b-col>
                    <b-col  cols="auto">Renovação</b-col>
                    <b-col>
                      <b-form-input v-model="selectedItem.renewalDate" type="date" id="renewalDate"></b-form-input>
                    </b-col>
                  </b-row>
                  </b-form-group>          
                </b-form>
              </b-col>
            </b-row>
    
            <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label=""
                    label-for="renewalAuto"
                    :label-cols="3"
                    :horizontal="true">

                    <input id="renewalAuto" type="checkbox" value="" v-model="selectedItem.renewalAuto"> Renovação automática
                  </b-form-group>  

                  </b-form>
                </b-col>
              </b-row>
              

            <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Valor de intalação/inicial"
                    label-for="installValue"
                    :label-cols="3"
                    :horizontal="true">
                    <div>
                      <b-row>
                        <b-col><b-form-input v-model="selectedItem.installValue" id="installValue" type="number"></b-form-input></b-col>
                        <b-col  cols="auto">Mensal</b-col>
                        <b-col><b-form-input v-model="selectedItem.value" id="value" type="number"></b-form-input></b-col>
                      </b-row>
                      
                    </div>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>
    
              <hr>

              <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Contato"
                    label-for="contact"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input class="text-uppercase" v-model="selectedItem.contactName" id="contact" type="text" ></b-form-input>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="E-mail"
                    label-for="contactEmail"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input v-model="selectedItem.contactEmail" id="contactEmail" type="text" ></b-form-input>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group label="Telefone" 
                      description=""
                      label-for="phone"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-input-group>
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class='fa fa-phone'></i>
                          </span>
                        </div>
                        <masked-input
                          type="tel"
                          name="phone"
                          class="form-control"
                          v-model="selectedItem.contactPhone"
                          :mask="['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                          :guide="true"               
                          >
                        </masked-input>
                      </b-input-group>

                      <!--
                      <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="[1]">
                        <b-form-checkbox :value="selectedUser.phonePublic">Exibir no portal</b-form-checkbox>              
                      </b-form-checkbox-group>
                      -->

                    </b-form-group>
                  </b-form>
                </b-col>
              </b-row>


              
              <hr>

           
             


              <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description="Número de dias antes do e-amail de aviso, separado por vírgula. Exemplo: Para enviar avisos com 7, 30 e 60 dias antes do vencimento, preencher com: 7,30,60"
                    label="Dias de aviso"
                    label-for="adviceDays"
                    :label-cols="3"
                    :horizontal="true">

                    <b-form-input id="adviceDays" type="text" value="" v-model="selectedItem.adviceDays"></b-form-input>
                  </b-form-group>  

                  </b-form>
                </b-col>
              </b-row>

              
              <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description="Permite configurar um e-mail para receber todas as alterações e avisos de vencimento relacionados ao contrato."
                    label="E-mail de aviso"
                    label-for="email"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input v-model="selectedItem.email" id="email" type="text" ></b-form-input>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label=""
                    label-for="email"
                    :label-cols="3"
                    :horizontal="true">

                    <input id="sendEmail" type="checkbox" value="" v-model="selectedItem.sendEmail"> Envio de e-mail HABILITADO
                  </b-form-group>  

                  </b-form>
                </b-col>
              </b-row>
              
              
          <b-input-group class="mb-4">
              <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
          </b-input-group>
        
          <div slot="footer" class="text-right">
       
            <b-button variant="github" class="mr-1 btn-brand" @click="save()" :disabled="!(editAccess || !selectedItem.id || selectedItem.id <= 0 || (selectedItem.responsible && $store.state.currentUser.id == selectedItem.responsible.id))" ><i class="fa fa-check"></i><span>Salvar Contrato</span></b-button>
           
          </div>

        </div>
        </b-form>
      </b-card>


      </b-modal>
  

      <b-modal v-model="actionModal"
              id="action-modal"
              centered
              hide-footer
              title="Atendimento"
              size="lg">

          <b-card>
           
            <b-form-textarea
                          id="description"
                          v-model="commentContent"
                          placeholder=""
                          rows="10"
                        ></b-form-textarea>

            <b-row>
                    <b-col cols="auto">
                        <b-form-group>
                            <label for="perPage" style="font-size: 0.8em">Status</label>
                            <b-form-select v-model="editStatusId" id="filterStatus" :plain="true" :options="this.contractStatusDDL">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
            </b-row>     
       

            <div slot="footer" class="text-right">
              <b-button variant="github" class="mr-1 btn-brand" @click="saveAction()"><i class="fa fa-check"></i><span>Salvar Atendimento</span></b-button>
            
            </div>

          </b-card>

     </b-modal>

     <b-modal :title="selectedDocument.filename" class="modal-danger" v-model="documentModal" @ok="documentModal = false" ok-variant="danger" hide-footer size="xl" v-if="selectedDocument">
          <div class="ratio ratio-16x9">
        
              <iframe
              :src="this.selectedDocument.url"
              :title="this.selectedDocument.filename"
              allowfullscreen
              width="100%"
              height="600px"
              ></iframe>
          </div>
      </b-modal>


    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  import MaskedInput from 'vue-text-mask'
  import { Switch as cSwitch } from '@coreui/vue'
  import FileDropAreaComponent from '../../components/FileDropAreaComponent.vue'

  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast,
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: '', licensedUntil: null}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      MaskedInput,
      FileDropAreaComponent
    },
    data: () => {
      return {
        editAccess: false,
        documentModal: false,
        selectedDocument: null,

        isBusyFile: false,
        fileItems: [],
        fileFields: [
          { key: 'action', label: '', sortable: false, thStyle: { width: "40px" } },
          { key: 'filename', label: 'Arquivo', sortable: true },
          { key: 'description', label: 'Descrição', sortable: true},
          
        ],
        fileSelectMode: 'single',



        isBusyHistory: false,
        historyItems: [],
        historyFields: [
          { key: 'createdIn', label: 'Data', sortable: true, thStyle: { width: "120px" }  },
          { key: 'history', label: 'Histórico', sortable: true},
          //{ key: 'action', label: '', sortable: false, thStyle: { width: "40px" } }
        ],
        historySelectMode: 'single',

        fileDescription: '',

        fileToSend: null,
        commentContent: null,
        editStatusId: 0,
        actionModal: false,


        tabInfo: 'C',
        departmentDDL: [],
        contractStatusDDL: [],
        contractTypeDDL: [],
        projectDDL: [
          {
            text: 'Contratos',
            value: 1
          },
          {
            text: 'Intranet',
            value: 2
          },
        ],
        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],

        bulkLicensedUntil: null,
      
        companyDDL: [],
  
        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        bulkModal: false,
        editModal: false,
        filters: {
          departmentId: 0,
          companyId: null,
          key: '',
          status: 'A',
          registeredId: 0,
          statusId: 0,
          typeId: 0
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          //{key: 'show_details', label: "", thStyle: { width: "40px" } },
          //{key: 'id' },
          //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
          {key: 'code', label: 'Número', sortable: true, thStyle: { width: "150px" }, class: 'text-center'  },
          {key: 'name2', label: 'Contrato', sortable: true },
          //{key: 'areaCode', label: 'Área', sortable: true, thStyle: { width: "100px" } },
          //{key: 'nro', label: 'Nro', sortable: true, thStyle: { width: "100px" } },
          {key: 'startDate', label: 'Início', sortable: true, thStyle: { width: "150px" }, class: 'text-center'  },
          {key: 'renewalDate', label: 'Renovação', sortable: true, thStyle: { width: "150px" }, class: 'text-center'  },
          //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
          //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
          //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
          //{key: 'description', label: 'Descrição', sortable: false },          
          {key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } },
          {key: 'st', label: 'Ativo', sortable: true, thStyle: { width: "40px" }, class: 'text-center' },
          { key: 'action', label: 'Ações', sortable: false, thStyle: { width: "90px" } , class: 'text-center'}
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      selectDepartmentDDL: function() {
        var list = [...this.departmentDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '- Todos -' })
        return list
      },

      departmentDDLOrdered: function() {
        var list = this.departmentDDL.sort((a,b) => (a.text > b.text) ? 1 : -1)       
        return list
      },

      selectContractTypeDDL: function() {
        var list = [...this.contractTypeDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '- Todos -' })
        return list
      },

      selectContractStatusDDL: function() {
        var list = [...this.contractStatusDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '- Todos -' })
        return list
      },
      
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return (this.filters.key == '' || (
                  this.$utils.filterString(item.name, this.filters.key)
                  || (this.filters.key == item.code)
                  //|| this.$utils.filterString(item.departmentName, this.filters.key)
                  //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  ))
                  && (this.filters.departmentId == 0 || (this.filters.departmentId == item.departmentId))
                  && (this.filters.typeId == 0 || (this.filters.typeId == item.typeId))
                  && (this.filters.statusId == 0 || (this.filters.statusId == item.statusId ))
                  && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )
                  
                              
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {
      async uploadFile() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        
        let formData = new FormData();

        formData.append('companyId', this.filters.companyId)
        formData.append('contractId', this.selectedItem.id)
        formData.append('description', this.fileDescription)
        formData.append('file', this.fileToSend);
        formData.append('uid', currentUser.id);
        formData.append('sid', currentUser.sid);

        await axios.post(
            this.$store.state.ws_url + "/contract/file/upload", formData
        ).then(function() {
          s.fileToSend = null
          s.getContractFiles(s.selectedItem)
          toast({
              type: VueNotifications.types.info,
              title: 'Arquivo',
              message: "Arquivo salvo com sucesso",
              timeout: 5000
          })
          
        }).catch(function (error) {
          console.log(error);
        });

      },

      closeActionModal() {
          this.actionModal = false;
        },

      openActionModal(item) {
        this.selectedItem = item
        this.editStatusId = item.statusId
        this.actionModal = true
      },

      async saveAction() {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          if(this.selectedItem != null && this.commentContent != null && this.commentContent.length > 0)  {
            var postData = { contractId: this.selectedItem.id, statusId: 5, history: this.commentContent, uid: currentUser.id, sid: currentUser.sid, statusId: this.editStatusId }

            await axios.post(
                  this.$store.state.ws_url + "/contract/action",
                  postData
              ).then(function (resp) {
                  s.closeActionModal();
                  s.refreshData();
              }
              ).catch(function (error) {
                  console.log(error.message);
                
              });
          }
          else {
            toast({
                        type: VueNotifications.types.warn,
                        title: 'Ação',
                        message: "Entre com uma observação antes de salvar.",
                        timeout: 5000
                    })
          }

        },

    
      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },

  
      changeStatus(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';
          this.saveItem(item);
        }
      },
  
      async saveItem(currentItem) {
  
        var s = this;
        var postData = {...currentItem};
  
        postData["companyId"] = s.filters.companyId
        postData["uid"] = this.$store.state.currentUser.id
        postData["sid"] = this.$store.state.currentUser.sid
        
        await axios.post(
            this.$store.state.ws_url + "/contract",
            postData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
        }
        ).catch(function (error) {
            console.log(error);
  
            toast ({
                type: VueNotifications.types.warn,
                title: 'Erro',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });
        
    },
  
    save() {
  
        let msgError = [];
  
        if(this.selectedItem.code.length <= 2)
            msgError.push("Identificador");
        
        if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )
  
            toast ({
                type: VueNotifications.types.error,
                title: 'Erro',
                message: msgErrorExt,
                timeout: 5000
            })
        }
        else {
            this.saveItem(this.selectedItem);
        }
    },
  
      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
        console.log(this.selectedItem);
      },

      openDocumentModal(item) {
            this.selectedDocument = item;
            this.documentModal=true;
      },

      closeBulkModal() {
        this.bulkModal = false;
      },
      openBulkModal(item) {
       
        this.bulkModal = true;
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        this.fileDescription = ''
        if(item == null) {
            this.selectedItem = { ...newItem }; 
            this.selectedItem.startDate = this.$utils.dateFormat(new Date())
            this.historyItems = []
            this.fileItems = [] 
        }
        else {
            this.selectedItem = { ...item };
            this.historyItems = []
            this.fileItems = []

            this.getContractFiles(this.selectedItem)
            this.getContractHistory(this.selectedItem)
        }
        this.tabInfo = 'C'
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items       
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
        if(!this.tableSelectable) {
            this.clearSelectedRows();
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      async getStatus() {
          var s = this
          var currentUser = this.$store.state.currentUser
          
          await axios.get(
              this.$store.state.ws_url + "/contract/status/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.contractStatusDDL = resp.data.obj;
          }
          ).catch(function (error) {
            console.log(error)
          });
  
      },

      async getType() {
          var s = this
          var currentUser = this.$store.state.currentUser
          
          await axios.get(
              this.$store.state.ws_url + "/contract/type/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.contractTypeDDL = resp.data.obj;
          }
          ).catch(function (error) {
            console.log(error)
          });
  
        
      },

      async getDepartment() {
          var s = this
          var currentUser = this.$store.state.currentUser

          await axios.get(
              this.$store.state.ws_url + "/department/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.departmentDDL = resp.data.obj;
          }
          ).catch(function (error) {
            console.log(error)
          });
  
      },

      async getContractHistory(item) {
          var s = this
          var currentUser = this.$store.state.currentUser

          await axios.get(
              this.$store.state.ws_url + "/contract/history?contractId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.historyItems = resp.data.obj;
          }).catch(function(error) {
            console.log(error)
          })
          
          this.isBusy = false;
        },


      async getContractFiles(item) {
          var s = this
          var currentUser = this.$store.state.currentUser

          await axios.get(
              this.$store.state.ws_url + "/contract/file?contractId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.fileItems = resp.data.obj;
          }).catch(function(error) {
            console.log(error)
          })
          
          this.isBusy = false;
        },


        async getGroupCompany() {
            var s = this
            var currentUser = this.$store.state.currentUser

            await axios.get(
                this.$store.state.ws_url + "/company/groupddl?uid=" + currentUser.id + "&sid=" + currentUser.sid

            ).then(function(resp) {
              s.companyDDL = resp.data.obj;
            })
            .catch(function(error) {
                console.log(error);
            })
          
        },

        async getEditAccess() {
            var s = this
            var currentUser = this.$store.state.currentUser

            await axios.get(
                this.$store.state.ws_url + "/user/checkaccess?uid=" + currentUser.id + "&sid=" + currentUser.sid + "&accessCode=SYS_CONTRACT_EDIT"

            ).then(function(resp) {
              s.editAccess = true
            })
            .catch(function(error) {
              s.editAccess = false
            })
          
        },


      async refreshData() {
        var s = this
        var currentUser = this.$store.state.currentUser
        this.isBusy = true

      
        await axios.get(
            this.$store.state.ws_url + "/contract?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function (resp) {
            s.items = resp.data.obj;
        }
        ).catch(function (error) {
            toast ({
                type: VueNotifications.types.error,
                title: 'Erro',
                message: 'Sem permissão de acesso. Verifique e tente novamente.',
                timeout: 3000
            })
        })

        this.isBusy = false;
       
      },

      changeCompany() {
        this.getDepartment();
        this.refreshData();
      }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId
      this.getEditAccess()
      this.getStatus()
      this.getType()
      this.changeCompany()
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>